/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HubAchievementResponse } from './HubAchievementResponse';
import {
    HubAchievementResponseFromJSON,
    HubAchievementResponseFromJSONTyped,
    HubAchievementResponseToJSON,
    HubAchievementResponseToJSONTyped,
} from './HubAchievementResponse';
import type { DropAchievementConditionProgress } from './DropAchievementConditionProgress';
import {
    DropAchievementConditionProgressFromJSON,
    DropAchievementConditionProgressFromJSONTyped,
    DropAchievementConditionProgressToJSON,
    DropAchievementConditionProgressToJSONTyped,
} from './DropAchievementConditionProgress';

/**
 * 
 * @export
 * @interface MyDropAchievementEntry
 */
export interface MyDropAchievementEntry {
    /**
     * 
     * @type {HubAchievementResponse}
     * @memberof MyDropAchievementEntry
     */
    achievement: HubAchievementResponse;
    /**
     * 
     * @type {boolean}
     * @memberof MyDropAchievementEntry
     */
    unlocked: boolean;
    /**
     * 
     * @type {number}
     * @memberof MyDropAchievementEntry
     */
    unlockedAt?: number;
    /**
     * 
     * @type {Array<DropAchievementConditionProgress>}
     * @memberof MyDropAchievementEntry
     */
    progress: Array<DropAchievementConditionProgress>;
}

/**
 * Check if a given object implements the MyDropAchievementEntry interface.
 */
export function instanceOfMyDropAchievementEntry(value: object): value is MyDropAchievementEntry {
    if (!('achievement' in value) || value['achievement'] === undefined) return false;
    if (!('unlocked' in value) || value['unlocked'] === undefined) return false;
    if (!('progress' in value) || value['progress'] === undefined) return false;
    return true;
}

export function MyDropAchievementEntryFromJSON(json: any): MyDropAchievementEntry {
    return MyDropAchievementEntryFromJSONTyped(json, false);
}

export function MyDropAchievementEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyDropAchievementEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'achievement': HubAchievementResponseFromJSON(json['achievement']),
        'unlocked': json['unlocked'],
        'unlockedAt': json['unlockedAt'] == null ? undefined : json['unlockedAt'],
        'progress': ((json['progress'] as Array<any>).map(DropAchievementConditionProgressFromJSON)),
    };
}

export function MyDropAchievementEntryToJSON(json: any): MyDropAchievementEntry {
    return MyDropAchievementEntryToJSONTyped(json, false);
}

export function MyDropAchievementEntryToJSONTyped(value?: MyDropAchievementEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'achievement': HubAchievementResponseToJSON(value['achievement']),
        'unlocked': value['unlocked'],
        'unlockedAt': value['unlockedAt'],
        'progress': ((value['progress'] as Array<any>).map(DropAchievementConditionProgressToJSON)),
    };
}

